export const data = [
  {
    id: 1,
    name: "Classic",
    category: "burger",
    image: "https://gyazo.com/1db798635d812f55e012699d726ccf29.jpg",
    price: "$ 900",
  },
  {
    id: 2,
    name: "Big Duo",
    category: "burger",
    image: "https://gyazo.com/eb35f6b69cf9fdada24b252a195dd95d.jpg",
    price: "$ 1000",
  },
  {
    id: 3,
    name: "Crunchy Onion",
    category: "burger",
    image: "https://gyazo.com/efc414c6c68e261c1493bcfab4812ab3.jpg",
    price: "$ 1000",
  },
  {
    id: 4,
    name: "Cheese classic",
    category: "burger",
    image: "https://gyazo.com/69bfdfca51155b648022a26f3a511632.jpg",
    price: "$ 900",
  },
  {
    id: 5,
    name: "Patty Melt",
    category: "burger",
    image: "https://gyazo.com/96224bf42a1b7f35a9a6fb3c360da397.jpg",
    price: "$ 1000",
  },
  {
    id: 6,
    name: "Smashnifica",
    category: "burger",
    image: "https://gyazo.com/a3f6a5212066660d151b2d868b15939c.jpg",
    price: "$1000",
  },
];
